import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import solutionData from '../data/solutionData';
import '../styles/Solutions.css';

const Solutions = () => {
  return (
    <main className="solutions-page">
      <SEO
        title="Business & Technology Solutions | Bularis Tech"
        description="Explore focused Bularis Tech solutions that connect systems and address practical payment, workflow, and digital business needs."
        path="/solutions"
      />
      <header className="solutions-header">
        <span className="solutions-eyebrow">Business solutions</span>
        <h1>Solutions</h1>
        <p>
          Explore focused technology solutions designed to connect systems, improve customer
          experiences, and solve practical business challenges.
        </p>
      </header>

      <section className="solutions-grid" aria-label="Bularis Tech solutions">
        {solutionData.map((solution) => (
          <article className="solution-card" key={solution.id}>
            <h2>{solution.title}</h2>
            <p>{solution.summary}</p>
            <Link to={solution.path}>Explore this solution <span aria-hidden="true">→</span></Link>
          </article>
        ))}
      </section>
    </main>
  );
};

export default Solutions;
